import React from 'react';
import DashboardStatusButton from 'components/atoms/DashboardStatusButton';
import { IBranch } from 'types/Branches';
import { Link } from 'react-router-dom';

export interface IDashboardStatusCard {
	className?: string;
	branches: IBranch[];
	incidentPath?: string;
	dateFrom?: string;
	isAdminManager?: boolean;
}

const DashboardStatusCard: React.FC<IDashboardStatusCard> = ({
	className = '',
	branches,
	incidentPath,
	dateFrom,
	isAdminManager = false,
}) => {
	var incident_total: JSX.Element | string = '';

	const tableClassName = isAdminManager
		? `${className} px-8 w-full font-inter text-scorpion-500 table-fixed`
		: `${className} px-8 w-full font-inter text-scorpion-500`;

	const branchColWidth = isAdminManager ? 'w-[40%]' : '';
	const totalColWidth = isAdminManager ? 'w-[30%]' : '';
	const statusColWidth = isAdminManager ? 'w-[30%]' : '';

	return (
		<table className={tableClassName}>
			<thead className="border-b border-scorpion-100">
				<tr>
					<th
						className={`text-secondary font-semibold text-left pb-2 ${branchColWidth}`}
					>
						Branch
					</th>
					<th
						className={`text-secondary font-semibold text-left pb-2 ${totalColWidth} ${
							isAdminManager ? 'pr-8' : 'pr-4'
						}`}
					>
						Total
					</th>
					<th
						className={`text-secondary font-semibold text-left pb-2 ${statusColWidth}`}
					>
						Status
					</th>
				</tr>
			</thead>
			<tbody>
				{branches.map((branch: IBranch) => {
					if (incidentPath === 'incidents') {
						incident_total = (
							<Link
								to={`/${incidentPath}?branch_name=${branch.name}&dateFrom=${dateFrom}`}
							>
								{branch.statistics.total}
							</Link>
						);
					} else {
						incident_total = <>{branch.statistics.total}</>;
					}
					return (
						<tr
							className="border-b border-scorpion-100 text-[14px]"
							key={branch.id}
						>
							<td className="py-4 font-normal">{branch.name}</td>
							<td className="py-4 font-normal underline">{incident_total}</td>
							<td>
								<div className="flex flex-row gap-x-2">
									{['draft', 'submitted', 'new', 'open', 'closed'].map(
										(status) => {
											const statIndex = status === 'new' ? 'newCount' : status;
											//@ts-ignore
											if (branch.statistics[statIndex] === 0) return null;

											const extraLinkQuery = `branch_name=${branch.name}&status=${status}&dateFrom=${dateFrom}`;
											return (
												<DashboardStatusButton
													key={`status-${branch.id}-${status}`}
													status={status}
													branch={branch.name}
													// @ts-ignore
													total={branch.statistics[statIndex]}
													modulePath={incidentPath}
													extraLinkQuery={extraLinkQuery}
												/>
											);
										}
									)}
								</div>
							</td>
						</tr>
					);
				})}
			</tbody>
		</table>
	);
};

export default DashboardStatusCard;
